export default theme => ({
  root: {
    overflow: 'hidden',
    position: 'relative',
  },
  wrapper: {
    transition: 'all ease 1s',
  },
  hasSidebar: {
    minHeight: '100%',
    background: '#fefefe',
    transition: 'transform .5s ease',
    '-webkit-backface-visibility': 'hidden',
    'backface-visibility': 'hidden',
    zIndex: 1,
    paddingBottom: 0.1,
    boxShadow: '0 0 10px hsla(0,0%,4%,.5)',
    transform: 'translateX(250px)',
  },
  container: {
    direction: 'rtl',
    justify: 'center',
    flexGrow: 1,
    padding: 16,
  },

  pageWrapper: {
    margin: '0 auto',
    [theme.breakpoints.up("lg")]: {
      width: 1170
    },
    [theme.breakpoints.up("md")]: {
      // width: 1170
    },
  },

  main: {
  },

  '@global': {
    'html, body, #root': {
      height: '100%',
      // overflow: 'auto'
    },
    'html,body,p,h1,h2,h3,h4,h5,h6': {
        lineHeight: 2
    },
    'html, body, input, textarea, button': {
      fontFamily: 'IRANSans',
      // fontSize: 13,
    },
    body: {
      textAlign: 'right',
      background: '#fefefe'
    },
    a: {
      textDecoration: 'none',
      color: '#303030',
      '&:hover': {
        color: '#fc4a38'
      },
      '&:visited': {
          color: '#4a4a4a'
      },
      '&:visited:hover': {
          color: '#fc6151'
      }
    },
    ul: {
        margin: 0,
        padding: 0,
        listStyle: 'none',
    },
    '.wp-caption': {
      maxWidth: '100%'
    },
    video: {
      maxWidth: '100%',
      minWidth: '100%',
    }
  },

  contentWrapper: {
    // fontWeight: 'bold'
  },

  topAds: {
    padding: 0,
  },

  paper: {
    padding: theme.spacing.unit * 2,
    textAlign: 'right',
    color: theme.palette.text.secondary,
  },

  widgetPaper: {
    padding: 0,
  },

});